import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const questions = ['What should I assess?', 'What should I record?', 'What should I analyze?', 'What should I validate?', 'When should I reassess?'];
export function FinalCTA() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-125" data-mp="83m6jnddjcvt">
      <div className="mx-auto max-w-xl" data-id="element-126" data-mp="m46s2raobmt0">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-white sm:text-4xl" data-id="element-127" data-mp="m2vl6ilxlyxo">
          Ready to stop second-guessing your DVO assessment?
        </h2>
        <p className="mt-3 text-center font-display text-lg font-600 uppercase leading-tight tracking-wide text-gold-400 sm:text-xl" data-id="element-128" data-mp="vtymnlirwfxh">
          In the next 15 minutes, you can have a structured system for organizing your next case.
        </p>

        <p className="mt-5 text-center text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-129" data-mp="zwmx1xn4xuwk">
          You don’t need another resource that simply gives you more information. You need a clear
          process for answering:
        </p>

        <ul className="mt-5 space-y-2" data-id="element-130" data-mp="2h4j0ywvdbqpo">
          {questions.map(question => <li key={question} className="rounded-lg border-l-2 border-gold-500 bg-navy-900 px-4 py-2.5 text-sm font-500 text-white" data-id="element-131" data-mp="2m1sykzswv8ol">
              {question}
            </li>)}
        </ul>

        <p className="mt-5 text-center text-sm leading-relaxed text-slate-300" data-id="element-132" data-mp="2v1fzlkhqach4">
          DVO Master Protocol™ brings it all together in one 6-volume clinical system.
        </p>

        <div className="mt-8 rounded-2xl border-2 border-gold-500 bg-navy-900 p-5 text-center sm:p-7" data-id="element-133" data-mp="34tu42l06xx6z">
          <p className="text-[11px] font-700 uppercase tracking-[0.22em] text-gold-400" data-id="element-134" data-mp="39rn9vcxl0p6q">
            Today’s price
          </p>
          <p className="mt-2 font-display text-6xl font-700 leading-none text-white sm:text-7xl" data-id="element-135" data-mp="3it38yoiy54vn">
            $27
            <span className="ml-2 align-middle font-display text-xl font-600 text-gold-400" data-id="element-136" data-mp="1jo3gleqt412g">
              USD
            </span>
          </p>
          <p className="mt-2 text-sm text-slate-400" data-id="element-137" data-mp="1eqtkxhctqt66">Total value: $374 USD</p>
          <p className="mt-3 text-xs leading-relaxed text-slate-300" data-id="element-138" data-mp="1sgx4g0kbk8rx">
            🌎 Automatic currency conversion where applicable
          </p>

          <div className="mt-6" data-id="element-139" data-mp="1nnu5te0oq94v">
            <CTAButton label="Yes, I want DVO Master Protocol™ — $27" subtext="Instant digital access · One-time payment · Lifetime access · 7-day guarantee" data-id="element-140" data-mp="22ebglnz7mbef" />
          </div>

          <div className="mt-6" data-id="element-141" data-mp="2bfsrmrxrfmw9">
            <Countdown data-id="element-142" data-mp="2beq32qnwtwji" />
          </div>

          <div className="mt-6" data-id="element-143" data-mp="27e7c0ytucuid">
            <ScarcityBar data-id="element-144" data-mp="27f8xlx8hgzec" />
          </div>
        </div>
      </div>
    </section>;
}